import { useTranslation } from '../../../i18n/useTranslation';
import {
  AUTH_TYPE_LABELS,
  AuthenticationType,
  TTS_SERVICE_LEVEL_LABELS,
  TtsServiceLevel,
  type BooksellerFilterState,
} from '../../../types/manageBooksellers';

interface Props {
  filters: BooksellerFilterState;
  onChange: (patch: Partial<BooksellerFilterState>) => void;
}

export default function BooksellerListFilters({ filters, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-3 mb-3">
      <input
        type="search"
        value={filters.q ?? ''}
        onChange={(e) => onChange({ q: e.target.value || undefined, page: 1 })}
        placeholder={t('App.Admin.Booksellers.BooksellerListFilters.SearchPlaceholder')}
        className="border border-neutral-300 rounded px-3 py-2 text-sm w-72"
        aria-label={t('App.Admin.Booksellers.BooksellerListFilters.SearchAriaLabel')}
      />

      <select
        value={filters.isActive === undefined ? '' : String(filters.isActive)}
        onChange={(e) => onChange({
          isActive: e.target.value === '' ? undefined : e.target.value === 'true',
          page: 1,
        })}
        className="border border-neutral-300 rounded px-2 py-2 text-sm"
        aria-label="Active filter"
      >
        <option value="">{t('App.Admin.Booksellers.BooksellerListFilters.ActiveAny')}</option>
        <option value="true">{t('App.Admin.Booksellers.BooksellerListFilters.ActiveYes')}</option>
        <option value="false">{t('App.Admin.Booksellers.BooksellerListFilters.ActiveNo')}</option>
      </select>

      <select
        value={filters.authType === undefined ? '' : String(filters.authType)}
        onChange={(e) => onChange({
          authType: e.target.value === '' ? undefined : (Number(e.target.value) as AuthenticationType),
          page: 1,
        })}
        className="border border-neutral-300 rounded px-2 py-2 text-sm"
        aria-label="Auth type filter"
      >
        <option value="">{t('App.Admin.Booksellers.BooksellerListFilters.AuthAny')}</option>
        {Object.entries(AUTH_TYPE_LABELS).map(([value, label]) => (
          <option key={value} value={value}>{t('App.Admin.Booksellers.BooksellerListFilters.AuthPrefix', { label })}</option>
        ))}
      </select>

      <select
        value={filters.ttsServiceLevel === undefined ? '' : String(filters.ttsServiceLevel)}
        onChange={(e) => onChange({
          ttsServiceLevel: e.target.value === '' ? undefined : (Number(e.target.value) as TtsServiceLevel),
          page: 1,
        })}
        className="border border-neutral-300 rounded px-2 py-2 text-sm"
        aria-label="TTS service level filter"
      >
        <option value="">{t('App.Admin.Booksellers.BooksellerListFilters.TtsAny')}</option>
        {Object.entries(TTS_SERVICE_LEVEL_LABELS).map(([value, label]) => (
          <option key={value} value={value}>{t('App.Admin.Booksellers.BooksellerListFilters.TtsPrefix', { label })}</option>
        ))}
      </select>
    </div>
  );
}
